import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment-timezone";
import React from "react";
import { Bar } from "react-chartjs-2";
import FinancialReportingService from "../../../common/service/reporting/FinancialReportingService";
import { displayPrice } from "../../../common/util/DisplayUtil";
import ReportDownloadMenuButton from "../ReportDownloadMenuButton";

export default function SalesByPaymentMethodReportDisplay({
  reportData,
  reportCriteria,
  reportTitle,
}) {
  const { startDate, endDate } = reportCriteria;

  const labels = reportData.map((data) => data.paymentMethodName);
  const reportOptions = {
    plugins: {
      title: {
        display: true,
        text:
          reportTitle +
          ": " +
          moment(startDate).format("MM/DD/YYYY") +
          " - " +
          moment(endDate).format("MM/DD/YYYY"),
      },
    },
    responsive: true,
    indexAxis: "y",
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
    maintainAspectRatio: false,
  };
  const data = {
    labels: labels,
    datasets: [
      {
        label: "Subtotal",
        data: reportData.map((data) => data.subtotal),
        backgroundColor: "rgba(99, 148, 255, 0.2)",
        borderColor: "rgba(99, 148, 255, 0.8)",
        borderWidth: 1,
      },
      {
        label: "Transaction Fee Total",
        data: reportData.map((data) => data.transactionFeeAmount),
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
    ],
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box style={{ height: `${labels.length * 42 + 50}px`, width: "100%" }}>
        <Bar options={reportOptions} data={data} />
      </Box>
      <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h5">Report Data</Typography>
        <ReportDownloadMenuButton
          reportData={reportData}
          getDownloadFileName={() =>
            `sales-report-by-payment-method-${moment(startDate).format("MM-DD-YYYY")}-${moment(endDate).format("MM-DD-YYYY")}.csv`
          }
          getUnderlyingData={() =>
            FinancialReportingService.getSalesReportUnderlyingData(
              reportCriteria
            )
          }
        />
      </Box>

      <TableContainer component={Paper}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "800" }}>Payment Method</TableCell>
              <TableCell sx={{ fontWeight: "800" }}>Subtotal</TableCell>
              <TableCell sx={{ fontWeight: "800" }}>
                Transaction Fee Amount
              </TableCell>
              <TableCell sx={{ fontWeight: "800" }}>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reportData.map((data, i) => (
              <TableRow key={i}>
                <TableCell>{data.paymentMethodName}</TableCell>
                <TableCell>{displayPrice(data.subtotal)}</TableCell>
                <TableCell>{displayPrice(data.transactionFeeAmount)}</TableCell>
                <TableCell>{displayPrice(data.total)}</TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell>
                <b>Total</b>
              </TableCell>
              <TableCell>
                <b>
                  {displayPrice(
                    reportData.reduce((acc, data) => data.subtotal + acc, 0)
                  )}
                </b>
              </TableCell>
              <TableCell>
                <b>
                  {displayPrice(
                    reportData.reduce(
                      (acc, data) => data.transactionFeeAmount + acc,
                      0
                    )
                  )}
                </b>
              </TableCell>
              <TableCell>
                <b>
                  {displayPrice(
                    reportData.reduce((acc, data) => data.total + acc, 0)
                  )}
                </b>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
